export class StudentWithCompGroup {
    id: number;
    userID: number;
    semesterID: number;
    studentID: number;
    compensationGroupID: number;
    studentFullName: string;
    compensationGroupName: string;
}